module.exports = __webpack_public_path__ + "img/fa-regular-400.190b0a81.svg";